import { GetSurgicalOrderSchedulingCounter } from 'domain/usecases/surgical-order/get-surgical-order-scheduling-counter'
import { SurgicalOrderRepository } from 'repository/repositories/surgical-order/surgical-order-repository'

export class RemoteGetSurgicalOrderSchedulingCounter
  implements GetSurgicalOrderSchedulingCounter
{
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  count(
    params: GetSurgicalOrderSchedulingCounter.Params
  ): Promise<GetSurgicalOrderSchedulingCounter.Model> {
    return this.surgicalOrderRepository.getSurgicalOrderSchedulingCounter(
      params
    )
  }
}
